export const CALCULATOR_SET_MODE = 'CALCULATOR_SET_MODE';
export const CALCULATOR_SET_PARAMETERS = 'CALCULATOR_SET_PARAMETERS';
export const CALCULATOR_SET_CRITERIA_PRODUCT = 'CALCULATOR_SET_CRITERIA_PRODUCT';
export const CALCULATOR_SET_CRITERIA_DURATION = 'CALCULATOR_SET_CRITERIA_DURATION';
export const CALCULATOR_SET_CRITERIA_MILEAGE = 'CALCULATOR_SET_CRITERIA_MILEAGE';
export const CALCULATOR_SET_CRITERIA_DEPOSIT = 'CALCULATOR_SET_CRITERIA_DEPOSIT';
export const CALCULATOR_SET_CRITERIA_SVCMAP = 'CALCULATOR_SET_CRITERIA_SVCMAP';
export const CALCULATOR_SET_CRITERIA_CUSTOMER = 'CALCULATOR_SET_CRITERIA_CUSTOMER';
export const CALCULATOR_SELECT_BENEFIT = 'CALCULATOR_SELECT_BENEFIT';
export const CALCULATOR_SELECT_SERVICE_INFO = 'CALCULATOR_SELECT_SERVICE_INFO';

export function setCalculatorMode(calculatorMode) {
    return { type: CALCULATOR_SET_MODE, payload: { calculatorMode } }
}
export function setCalculatorParameters(parameters) {
    return { type: CALCULATOR_SET_PARAMETERS, payload: { parameters } }
}
export function setCalculatorCriteriaProduct(productKey) {
    return { type: CALCULATOR_SET_CRITERIA_PRODUCT, payload: { productKey } }
}
export function setCalculatorCriteriaDuration(duration) {
    return { type: CALCULATOR_SET_CRITERIA_DURATION, payload: { duration } }
}
export function setCalculatorCriteriaMileage(mileage) {
    return { type: CALCULATOR_SET_CRITERIA_MILEAGE, payload: { mileage } }
}
export function setCalculatorCriteriaDeposit(deposit) {
    return { type: CALCULATOR_SET_CRITERIA_DEPOSIT, payload: { deposit } }
}
export function setCalculatorCriteriaSvcMap(svcMap) {
    return { type: CALCULATOR_SET_CRITERIA_SVCMAP, payload: { svcMap } }
}
export function setCalculatorCriteriaCustomer(customer) {
    return { type: CALCULATOR_SET_CRITERIA_CUSTOMER, payload: { customer } }
}
export function selectCalculatorBenefit(benefit) {
    return { type: CALCULATOR_SELECT_BENEFIT, payload: { benefit } }
}
export function selectServiceInformation(service) {
    return { type: CALCULATOR_SELECT_SERVICE_INFO, payload: { service } }
}
